module.exports = __webpack_public_path__ + "img/u73.02bfab19.svg";